import axios from "axios";

import { getHeaders } from "./headers";

const restAxiosInstance = axios.create();

function requestApi({ method, headers = {}, route, data, formData } = {}) {
  const configRequest = {
    method,
    credentials: "same-origin",
    "Access-Control-Allow-Origin": "*",
    headers: getHeaders({ customHeaders: headers, hasFormData: !!formData }),
    url: route,
    data,
  };

  const payloadMethods = ["post", "put", "patch"];
  if (payloadMethods.indexOf(method.toLowerCase()) >= 0) {
    configRequest.data = !formData ? JSON.stringify(data) : data;
  }

  return restAxiosInstance(configRequest);
}

export { requestApi };
